import React from "react";
import DataTable from "react-data-table-component";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Devices = ({ devices }) => {
  const navigate = useNavigate();

  // Columns for DataTable
  const columns = [
    { name: "Device Name", selector: (row) => row.name, sortable: true },
    {
      name: "Location", selector: (row) => row.location, sortable: true },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <span
          className={`px-3 py-1 rounded-full text-sm font-semibold ${
            row.status === "Online" ? "bg-green-600 text-white" : "bg-red-600 text-white"
          }`}
        >
          {row.status}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Last Updated",
      selector: (row) => row.lastUpdated,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <button
          onClick={() => navigate(`/devices/${row.id}`)}
          className="text-blue-400 hover:text-blue-600"
          title="View Details"
        >
          <FaEye size={18} />
        </button>
      ),
    },
  ];

  const customStyles = {
    table: { style: { backgroundColor: "#1f2937", color: "#fff" } },
    headCells: { style: { backgroundColor: "#374151", color: "#fff" } },
    rows: { style: { backgroundColor: "#1f2937", color: "#fff" } },
    pagination: { style: { backgroundColor: "#1f2937", color: "#fff" } },
  };

  return (
    <div className="bg-gray-900 text-white p-6 rounded-xl shadow-md">
      <h1 className="text-2xl font-bold mb-4">Devices</h1>

      <DataTable
        columns={columns}
        data={devices}
        pagination
        highlightOnHover
        customStyles={customStyles}
      />
    </div>
  );
};

export default Devices;
